/* eslint-disable import/prefer-default-export */
import useAxios from '../hooks/useAxios';

/**
 * Get product name selections.
 * @param {Object} params - The parameters object.
 * @param {Object} params.data - The data object containing the following properties:
 * @param {string} params.data.startDate - The start date.
 * @param {string} params.data.endDate - The end date.
 * @param {CancelToken} params.cancelToken - The cancel token for request cancellation.
 * @param {function} [params.onSuccess] - The function to call when the request is successful.
 * @param {function} [params.onError] - The function to call when the request is failed.
 * @param {function} [params.onSettled] - The function to call when the request is finished.
 * @returns {Promise<any>} The API response.
 */
export async function getProductNameSelections(params) {
  const { data, cancelToken, onSuccess, onError, onSettled } = params;
  const [status, result, rtCode, noPrivilegeMsg] = await useAxios(
    '/getProdNameList',
    data,
    true,
    cancelToken
  );
  onSettled?.();
  if (status) {
    onSuccess?.(result);
  } else {
    onError?.(result, rtCode, noPrivilegeMsg);
  }
}
